import {
    DOMAIN,
    Header,
    ContentType,
    GetFormData,
    Method,
    http
} from './api-utils';


export async function secKillList({page, size, keyword}) {
    return http({
        url: DOMAIN + '/api/sec-kill',
        method: Method.GET,
        params: {
            page,
            size,
            keyword
        }
    }).then(res => res.data)
}